import { BiLinkExternal, BiRightArrowAlt } from 'react-icons/bi'
import type { NavItem } from '../types'

export const communitySupport: NavItem = {
  name: 'Community & Support',
  pill: {
    text: 'New',
    variant: 'info',
    startDate: '2026-06-19',
    expiryDate: '2026-08-01',
  },
  linkSections: [
    {
      columns: 1,
      sections: [
        {
          header: 'Community & Support',
          items: [
            { name: 'PennyLane blog', href: '/blog?page=1' },
            { name: 'FAQs', href: '/faq' },
            {
              name: 'Discussion forum',
              href: 'https://discuss.pennylane.ai',
            },
            {
              name: 'Submit a demo',
              href: '/demos_submission',
            },
            { name: 'Get involved', href: '/get-involved' },
          ],
        },
        {
          header: 'From Xanadu',
          items: [
            {
              name: 'Xanadu blog',
              href: 'https://xanadu.ai/blog',
            },
            {
              name: 'Xanadu press and news',
              href: 'https://xanadu.ai/press',
            },
          ],
        },
      ],
    },
  ],
  cardSections: [
    {
      header: 'Latest Blog Post',
      type: 'content',
      cta: { text: 'View all', href: '/blog?page=1' },
      cards: {
        limit: 1,
        filters: {
          contentType: 'BLOG',
          sort: 'publication_date',
        },
        fallbackImageSrc:
          'https://assets.cloud.pennylane.ai/navbar/pennylane-generic-blog-thumbnail.png',
      },
    },
    {
      header: 'Help & Support',
      type: 'featured',
      cards: [
        {
          variant: 'white',
          title: 'Join the PennyLane discussion forum',
          description: `Get expert help and connect with the global PennyLane community.`,
          imageSrc:
            'https://assets.cloud.pennylane.ai/navbar/community-forum-small.png',
          imageSize: 'small',
          button: {
            text: 'Go to forum',
            variant: 'secondary',
            icon: BiLinkExternal,
          },
          href: 'https://discuss.pennylane.ai',
        },
      ],
    },
    {
      header: 'PennyLane newsletter',
      type: 'featured',
      cards: [
        {
          variant: 'primary-blue',
          title: 'PennyLane newsletter',
          description: `Want to get the latest quantum updates delivered to your inbox? Join the list.`,
          imageSrc:
            'https://assets.cloud.pennylane.ai/navbar/newsletter-small.png',
          imageSize: 'small',
          button: {
            text: 'Subscribe now',
            variant: 'secondary',
            icon: BiRightArrowAlt,
          },
          href: 'https://bit.ly/434uPcQ',
          pill: {
            text: 'New',
            variant: 'info',
            startDate: '2026-06-19',
            expiryDate: '2026-08-01',
          },
        },
      ],
    },
  ],
}
